import React, { useState, useEffect } from "react";
import ColorFieldComponent from "../../../Components/Forms/ColorFieldComponent";
import { ConeConfiguracao } from "../../../Models/Paineis/ConeDeRisco/ConeConfiguracao";
import { ReactComponent as GraficoSucesso } from "../../../Svgs/porcentagem_sucesso.svg";
import { ReactComponent as GraficoTratativa } from "../../../Svgs/porcentagem_tratativas.svg";
import { ReactComponent as GraficoSemNc } from "../../../Svgs/porcentagem_sem_nc.svg";
import { ReactComponent as GraficoEventos } from "../../../Svgs/porcentagem_eventos.svg";
import { ReactComponent as GraficoAcumulado } from "../../../Svgs/valor_acumulado.svg";
import { ReactComponent as GraficoAcumuladoEmRisco } from "../../../Svgs/valor_acumulado_em_risco.svg";

const ConeConfiguracaoGraficoDireitaTab = (props: any) => {
    const [coneConfiguracao, setConeConfiguracao] = useState<any>(new ConeConfiguracao());

    useEffect(() => {
        setConeConfiguracao(props.coneConfiguracao);
    }, [props.coneConfiguracao]);

    return (
    <div>
        <div className="row">
            <div className="col-md-2 mb-2">
                <ColorFieldComponent
                    label="Cor Sucesso"
                    field='cor_sucesso_grafico_direita'
                    model={coneConfiguracao}
                    colorChangedCallback={props.colorChangedCallback}
                />
                <GraficoSucesso />
            </div>
            <div className="col-md-2 mb-2">
                <ColorFieldComponent
                    label="Cor Tratativa"
                    field='cor_tratativa_grafico_direita'
                    model={coneConfiguracao}
                    colorChangedCallback={props.colorChangedCallback}
                />
                <GraficoTratativa />
            </div>
            <div className="col-md-2 mb-2">
                <ColorFieldComponent
                    label="Cor Sem NC"
                    field='cor_sem_nc'
                    model={coneConfiguracao}
                    colorChangedCallback={props.colorChangedCallback}
                />
                <GraficoSemNc />
            </div>
            <div className="col-md-2 mb-2">
                <ColorFieldComponent
                    label="Cor Eventos"
                    field='cor_eventos_grafico_direita'
                    model={coneConfiguracao}
                    colorChangedCallback={props.colorChangedCallback}
                />
                <GraficoEventos />
            </div>
            <div className="col-md-2 mb-2">
                <ColorFieldComponent
                    label="Cor Acumulado"
                    field='cor_valor_acumulado'
                    model={coneConfiguracao}
                    colorChangedCallback={props.colorChangedCallback}
                />
                <GraficoAcumulado />
            </div>
            <div className="col-md-2 mb-2">
                <ColorFieldComponent
                    label="Cor Acumulado Em Risco"
                    field='cor_valor_acumulado_em_risco'
                    model={coneConfiguracao}
                    colorChangedCallback={props.colorChangedCallback}
                />
                <GraficoAcumuladoEmRisco />
            </div>
        </div>
        <div className="row">
        <div className="col-md-2 mb-2">
                <ColorFieldComponent
                    label="Cor Padrão"
                    field='cor_padrao_grafico_direita'
                    model={coneConfiguracao}
                    colorChangedCallback={props.colorChangedCallback}
                />
            </div>
            <div className="col-md-2 mb-2">
                <ColorFieldComponent
                    label="Cor Fonte"
                    field='cor_fonte_grafico_direita'
                    model={coneConfiguracao}
                    colorChangedCallback={props.colorChangedCallback}
                />
            </div>
        </div>
    </div>
    );
}

export default ConeConfiguracaoGraficoDireitaTab;